import { useEffect, useState } from "react";
import { Container, Row, Table } from "react-bootstrap";
import { collection, onSnapshot, query, where, Timestamp } from "firebase/firestore";
import { db } from "../firebase";

export default function Players() {
  const [players, setPlayers] = useState([]);

  useEffect(() => {
    const startOfToday = new Date("2025-11-25");
    startOfToday.setHours(0, 0, 0, 0);
    const todayTs = Timestamp.fromDate(startOfToday);
    const q = query(
      collection(db, "players"),
      where("validated", "==", true),
      where("createdAt", ">=", todayTs)
    );
    const unsub = onSnapshot(q, (snapshot) => {
      const list = [];
      snapshot.forEach((doc) => {
        const data = doc.data();
        if (data.deleted !== true) {
          list.push({ id: doc.id, ...data });
        }
      });
      setPlayers(list);
    });
    return unsub;
  }, []);

  const fullName = (p) =>
    [p.name, p.paternalName, p.maternalName].filter(Boolean).join(" ");

  return (
    <Container>
      <Row className="justify-content-center">
        <h2>Jugadores registrados</h2>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>#</th>
              <th>Nombre</th>
              <th>Ciudad</th>
              <th>Fecha de nacimiento</th>
            </tr>
          </thead>
          <tbody>
            {players.map((p, i) => (
              <tr key={p.id}>
                <td>{i + 1}</td>
                <td>{fullName(p)}</td>
                <td>{p.city}</td>
                <td>{p.birthDate}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Row>
    </Container>
  );
}
